import { AddToAssortmentItem, MinimalItem, PlanItem } from 'src/pages/AssortmentBuild/Planning.types';

export const PlanErrorKey = {
  Assortment: 'assortment',
  Allocation: 'allocation',
  Cart: 'cart',
} as const;

export type PlanErrorKey = (typeof PlanErrorKey)[keyof typeof PlanErrorKey];

export type PlanErrors = Record<PlanErrorKey, boolean>;

export const planErrorMessages: Record<PlanErrorKey, string> = {
  [PlanErrorKey.Assortment]: 'Cannot Fetch Assortment Plan Queue',
  [PlanErrorKey.Allocation]: 'Cannot Fetch Allocation Plan Queue',
  [PlanErrorKey.Cart]: 'Cannot Fetch Add to Assortment Status',
};

export interface PlanStatusData {
  items: MinimalItem[];
  badgeColor: string;
}

export interface ParsedPlanData {
  pending: PlanItem[];
  queued: PlanItem[];
  processing: PlanItem[];
  predicting: PlanItem[];
  completed: PlanItem[];
  failed: PlanItem[];
}

export interface ProcessedPlanData {
  pending: PlanStatusData;
  queued: PlanStatusData;
  processing: PlanStatusData;
  predicting: PlanStatusData;
  completed: PlanStatusData;
  failed: PlanStatusData;
}

export interface ParsedCartData {
  processing: AddToAssortmentItem[];
  failed: AddToAssortmentItem[];
}

export interface ProcessedCartData {
  processing: PlanStatusData;
  failed: PlanStatusData;
}
